export const isIframed = () => window.parent && window.parent !== window;
